// extracted by mini-css-extract-plugin
export var contentBody = "_bz-a";
export var headerImage = "_bz-2";
export var imageActions = "_bz-7";
export var imageButton = "_bz-8";
export var imageButtonIcon = "_bz-9";
export var imageHeader = "_bz-4";
export var imageHeaderText = "_bz-5";
export var imageOverlay = "_bz-3";
export var imageTitle = "_bz-6";
export var imageWrapper = "_bz-1";
export var taskList = "_bz-b";
export var widget = "_bz-0";